import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
// ARR-WORKFORCE-SHELL-001 — Verbindlicher Layout-Vertrag fuer Workforce-Seiten
import "@/styles/workforce-shell.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
